import { render, staticRenderFns } from "./CancellationCompensationPanel.vue?vue&type=template&id=1cfaca9e&scoped=true"
import script from "./CancellationCompensationPanel.vue?vue&type=script&lang=js"
export * from "./CancellationCompensationPanel.vue?vue&type=script&lang=js"
import style0 from "./CancellationCompensationPanel.vue?vue&type=style&index=0&id=1cfaca9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfaca9e",
  null
  
)

export default component.exports